import React from 'react';
import './Image.scss';

const Image = props => {
  const classes = "Image " + props.className;

  return (
    <div className={classes}>
    </div>
    );
}

export default Image;
